const getCookie = (name) => {
    if (typeof document === 'undefined') {
        return null;
    }
    const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));
    if (!cookie) {
        return null;
    }
    return cookie.split('=')[1];
};
export const uid = () => { var _a; return typeof window !== 'undefined' ? (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('user_id') : null; };
export const cid = () => {
    const gaCookie = getCookie('_ga');
    if (gaCookie) {
        const pattern = /(\d+\.\d+)$/;
        const match = gaCookie.match(pattern);
        if (match) {
            return match[0];
        }
        return '';
    }
    return '';
};
export const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url === null || base64Url === void 0 ? void 0 : base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
};
